module.exports = __webpack_public_path__ + "img/privacy-terms-hover.6b22d042.svg";